import React from 'react'
import Header from '../../../header'

const CourseHeader = () => {
  return (
    <div><Header /></div>
  )
}

export default CourseHeader